<template>
  <div>
    <Modal
      v-model="domainModal"
      title="查看解析的二级域名状态">
      <Alert show-icon type="success" >默认显示7个二级域名的解析状态</Alert>
        <Row>
            <Table
              stripe
              border
              highlight-row
              :loading="tableLoading"
              ref="table"
              :data="table.data"
              :columns="table.columns"></Table>
        </Row>
    </Modal>
  </div>
</template>

<script>

import { getDomainResolves } from '@/api/opscenter'

export default {
  name: 'DnsRecordList',
  data () {
    return {
      tableLoading: false,
      domainModal: false,
      domainName: '',
      node: null,
      submitLoading: false,
      domainData: [],
      defaultDomains: ['us', 'ca', 'de', 'fr', 'uk', 'es', 'it', 'jp'],
      envRules: {
        envName: { required: true, trigger: 'blur', message: '域名不能为空' }
      },
      table: {
        data: [],
        columns: [
          {
            title: '名称',
            key: 'DomainName',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            minWidth: 100,
            title: '域名状态',
            align: 'center',
            key: 'DomainStatus',
            render: (h, params) => {
              const row = params.row
              const color = row.DomainStatus === '1' ? 'success' : 'warning'
              const text = row.DomainStatus === '1' ? '正常' : '解析中'
              return h('Tag', {
                props: {
                  type: 'dot',
                  color: color
                }
              }, text)
            }
          }
        ]
      }
    }
  },
  created: function () {
  },
  methods: {
    onSubmit () {
      return false
    },
    show (name) {
      this.domainModal = true
      this.domainName = name
      this.defaultDomainsInit()
      // 调用后台接口查询域名状态 domainData
      let data = {
        domains: this.domainData.join(',')
      }
      this.tableLoading = true
      console.log(11111111111111111111)
      getDomainResolves(data).then(res => {
        let result = res.data
        this.table.data = result
        this.table.count = result.count
        this.tableLoading = false
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    batchShow (lst) {
      this.domainModal = true
      for (let i in lst) {
        this.defaultDomainsInitBatch(lst[i].DomainName)
      }
    },
    defaultDomainsInit () {
      this.domainData = []
      for (let i in this.defaultDomains) {
        this.domainData.push(this.defaultDomains[i] + '.' + this.domainName)
      }
    },
    defaultDomainsInitBatch (domainName) {
      for (let i in this.defaultDomains) {
        this.domainData.push({
          envName: this.defaultDomains[i] + '.' + domainName
        })
      }
    },
    cancelModal () {
      this.domainData = []
    },
    removeEnvItem (index) {
      this.domainData.splice(index, 1)
    },
    addEnvItem () {
      this.domainData.push({
        envName: '.' + this.domainName
      })
    },
    ok () {
      const allValid = this.validForm()
      if (allValid) {
        this.submitLoading = true
        let data = {
          domain_name: this.domainName,
          names: this.domainData.map(item => item.envName),
          node: this.node
        }
        console.log(data)
        createDnsRecord(data).then(res => {
          this.$Notice.success({
            title: '操作成功！'
          })
          this.submitLoading = false
          this.cancelModal()
        }).catch(res => {
          this.submitLoading = false
          this.cancelModal()
          console.log(res.response)
          if (res.request) {
            this.$Notice.error({
              title: '操作失败！',
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '操作失败！'
            })
          }
        })
      } else {
        this.$Notice.warning({
          title: '表单未填写完整，请检查！'
        })
      }
      this.cancelModal()
    }
  }
}
</script>

<style scoped>

</style>
